module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAMAAADX9CSSAAAAAXNSR0IB2cksfwAAAGNQTFRFAAAA////////////////////////////////////////////////////////////////////AAAA////AAAA////AAAA////////AAAA/v7+////////////////////////8/NolAAAACF0Uk5TADyu7/7/rRu/z5xXvh/2WfXcAsADrwGdWgS+2/j7zptYEwZ/XQAAAK1JREFUeJx9kesagiAMhofM4hBDicxMy/u/yjyhUNr+bLzfnm8DAMZgGccc+YlBHGeBUmnQSuIlwoYo9FkqzMqp3HpcWYTySrGnJzEXDNNhdjnfZILByWzKXKW8UnzKqFM+GE0p/8Lg87/9P/732T872IehTXgd7iPIRfhBTSjp6Tdctms9vKd11TjS1dR20X4CX2/rrXphAzoWlv/KxpGJEIfu+n2hPxbMvmDgA8apBxUPyhf9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/search_icon.png
// module id = 591
// module chunks = 0